import getMenuItems from "@casino/actions/getMenuItemFilterOptions";
import Dropdown from "@casino/legacyUi/Dropdown";
import SelectPlaceholder from "@casino/legacyUi/SelectPlaceholder";
import { Checkbox, cn } from "@workspace/frontend-ui";
import Log from "@workspace/nextjs_utils/src/Log";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import getFilteredOptions from "./helpers/getFilteredOptions";

type Props = {
  type: "categories" | "providers";
  menuItem?: string;
  theme?: string;
};

const SelectFilterOptions: FC<Props> = ({ type, menuItem, theme }) => {
  const [options, setOptions] = useState<FilterOption[]>([]);
  const pathname = usePathname();

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const initOptions = await getMenuItems({ type, menuItem, theme });
        const filteredOptions = getFilteredOptions(
          pathname,
          initOptions || [],
          type,
        );
        setOptions(filteredOptions);
      } catch (error) {
        Log.error("Error fetching options", { error });
      }
    };

    fetchOptions();
  }, [type, menuItem, pathname, theme]);

  if (options.length === 0) {
    return <SelectPlaceholder />;
  }
  return (
    <>
      {options.map((item) => (
        <Dropdown.Option value={item.value} key={item.value}>
          {({ selected, active }) => (
            <div
              className={cn(
                "flex items-center gap-2 rounded-lg px-2 py-2 text-sm",
                active && "bg-accent",
                selected ? "text-primary" : "text-muted-foreground",
              )}
            >
              <Checkbox
                checked={selected}
                aria-hidden
                tabIndex={-1}
                className="pointer-events-none"
              />
              <span>{item.label}</span>
            </div>
          )}
        </Dropdown.Option>
      ))}
    </>
  );
};
export default SelectFilterOptions;
